// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.keyword[data-v-5ca97009] {\n  font-size: 25px;\n  font-weight: 700;\n  margin-right: 5px;\n}\n.key-count[data-v-5ca97009] {\n  color: #666;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
